module.exports = "<p>\n  tenant-admin-information works!\n</p>\n"